import { render, staticRenderFns } from "./a-scroll-indicator.vue?vue&type=template&id=01654466"
import script from "./a-scroll-indicator.vue?vue&type=script&lang=js"
export * from "./a-scroll-indicator.vue?vue&type=script&lang=js"
import style0 from "./a-scroll-indicator.vue?vue&type=style&index=0&id=01654466&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports